module.exports = __webpack_public_path__ + "static/media/Inox.171b5893.png";